import FeatherIcon from "feather-icons-react";
import moment from "moment";
import { Popup } from "semantic-ui-react";
import { formatMoneyWithCurrency, formatRut } from "src/utils/formatter";

const DocumentContent = ({ data, docId, type, endType, originType, origin }) => {

  const isDebit = (() => {
    if (data?.meta?.isReceived !== undefined) return !!data.meta.isReceived;
    if (endType === 'OBLIGATION') return true;
    if ((data?.type || '').toUpperCase() === 'SPEND') return true;
    return type !== 'inMatch';
  })();

  const amountClass = isDebit ? 'tw-text-red-500' : 'tw-text-green-500';

  const findMatchInfo = () => {
    const matches = data?.meta?.matchs;
    if (!matches) return null;

    if (type === 'outMatch' && originType === 'OBLIGATION' && endType === 'TAX_DOCUMENT') {
      const outMatchFound = matches.inMatch?.find(match => match.id === docId);
      if (outMatchFound) {
        return {
          type: 'outMatch',
          matchData: outMatchFound,
        };
      }
    } else if (type === 'inMatch' && endType != 'OBLIGATION') {
      const inMatchFound = matches.inMatch?.find(match => match.id === docId);
      if (inMatchFound) {
        return {
          type: 'inMatch',
          matchData: inMatchFound,
        };
      }
    } else if (type === 'inMatch' && endType === 'OBLIGATION') {
      const outMatchFound = matches.outMatch?.find(match => match.id === docId);
      if (outMatchFound) {
        return {
          type: 'outMatch',
          matchData: outMatchFound,
        };
      }
    } else if (type === 'outMatch' && endType != 'OBLIGATION') {
      const outMatchFound = matches.outMatch?.find(match => match.id === docId);
      if (outMatchFound) {
        return {
          type: 'outMatch',
          matchData: outMatchFound,
        };
      }
    } else if (type === 'outMatch' && endType === 'OBLIGATION' && originType === 'OBLIGATION') {
      const matchFound =
        matches.inMatch?.find(match => match.id === docId) ||
        matches.outMatch?.find(match => match.id === docId);
      if (matchFound) {
        return {
          type: 'outMatch',
          matchData: matchFound,
        };
      }
    } else if (type === 'outMatch' && endType === 'OBLIGATION') {
      const inMatchFound = matches.outMatch?.find(match => match.id === docId);
      if (inMatchFound) {
        return {
          type: 'outMatch',
          matchData: inMatchFound,
        };
      }
    } else if (type === 'outMatch' && endType === 'TAX_DOCUMENT') {
      const inMatchFound = matches.inMatch?.find(match => match.id === docId);
      if (inMatchFound) {
        return {
          type: 'outMatch',
          matchData: inMatchFound,
        };
      }
    }
    return null;
  };

  const matchInfo = findMatchInfo();
  const matchData = matchInfo?.matchData;
  const userRelated = matchInfo?.matchData?.userRelated;

  const matchUser = userRelated
    ? `Hecho por ${userRelated?.email ?? "—"} (${moment(userRelated?.date).format("DD/MM/YYYY HH:mm")})`
    : data?.userRelated?.email
      ? `Hecho por ${data.userRelated.email} (${moment(data.userRelated.date).format("DD/MM/YYYY HH:mm")})`
      : null;

  const amountValue = endType === 'MANUAL'
    ? data?.amount
    : (matchData?.matchedAmount || matchData?.localValue || matchData?.amount);


  const name = data?.meta?.isReceived ? data?.meta?.issuerName : data?.meta?.receiverName || data?.meta?.descriptionText;
  const rut = data?.meta?.isReceived ? formatRut(data?.meta?.issuerId) : formatRut(data?.meta?.receiverId);

  return (
    <>
      <div className="tw-flex tw-py-2 tw-items-center tw-px-2 tw-min-h-[49px]">
        <div className="tw-w-[15%]">
          <p className={`${amountClass} tw-text-sm tw-font-semibold !tw-p-0 !tw-m-0`}>
            {formatMoneyWithCurrency(Math.abs(amountValue || 0))}
          </p>
        </div>
        <div className="tw-w-[15%]">
          <p className="tw-text-sm tw-font-semibold !tw-p-0 !tw-m-0 tw-text-gray-600">
            {(() => {
              const d =
                endType === "MANUAL"
                  ? data?.userRelated?.date || data?.documentDate
                  : data?.documentDate;
              const m = d ? moment(d) : null;
              return m?.isValid?.() ? m.format("DD/MM/YYYY") : "—";
            })()}
          </p>
        </div>
        <div className="tw-w-[70%]">
          <div className="tw-flex tw-gap-2">
            <p className={`tw-text-gray-600 tw-text-sm tw-font-normal !tw-m-0 !tw-p-0`}>{endType === 'MANUAL' && origin == 'manual' ? 'Match realizado Manualmente' : endType === 'MANUAL' && origin == 'clay' ? 'Match realizado en Clay' :  data?.meta?.summary || data?.meta?.typeLabel}</p>
            <p className={`${endType === 'MANUAL' ? 'tw-hidden' : 'tw-block'} tw-text-blue-600 tw-text-sm tw-font-normal !tw-p-0 !tw-m-0`}>#{data?.meta?.documentId || data?.meta?.number || '-'}</p>

            {
              matchUser && (
                <Popup
                  trigger={
                    <FeatherIcon
                      icon="info"
                      size={18}
                      className="tw-text-white"
                      fill="#2563eb"
                      stroke="white"
                    />
                  }
                  content={matchUser}
                  disabled={!matchUser}
                  position="top center"
                  hoverable
                  inverted
                />
              )
            }
          </div>
          <div className={`${endType === 'MANUAL' ? 'tw-hidden' : 'tw-block'} tw-flex tw-min-h-4"`}>
            {
              rut &&
              <div className="tw-min-w-24">
                <p className="tw-text-gray-600 tw-text-sm tw-font-bold !tw-p-0 !tw-m-0">{rut}</p>
              </div>
            }
            <Popup
              trigger={
                <p className="tw-text-gray-600 tw-text-sm tw-font-bold !tw-p-0 !tw-m-0 tw-truncate">
                  {rut ? ` ${name}` : name}
                </p>
              }
              content={name}
              disabled={!name || name.length <= 40}
              position="top center"
              hoverable
              inverted
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DocumentContent;